import { FunctionComponent, useCallback } from 'react';
import StarRating from '../../../../components/StarRating';
import { SearchIndexCourseFilters } from '@shared/types';
import FacetFilterSection from '../FacetFilterSection';
import styles from './styles.module.scss';

type MinimumRatingFilterProps = {
    value?: SearchIndexCourseFilters['minimum_rating'];
    onChange: (newValue: SearchIndexCourseFilters['minimum_rating']) => void;
};

export const MinimumRatingFilter: FunctionComponent<MinimumRatingFilterProps> = ({
    value,
    onChange,
}) => {
    const handleRatingChange = useCallback(
        (newValue: number) => {
            const boundedRating = Math.min(
                newValue,
                5
            ) as SearchIndexCourseFilters['minimum_rating'];
            return onChange(boundedRating);
        },
        [onChange]
    );
    return (
        <FacetFilterSection
            name="Min Rating"
            ariaLabel="Filter by rating"
            numberOfIntiallyVisible={Infinity}
            className={styles.container}
        >
            <StarRating
                className={styles.rating}
                rating={value || 0}
                onChange={handleRatingChange}
            />
            <></>
        </FacetFilterSection>
    );
};

export default MinimumRatingFilter;
